import * as Primitive from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

export const TooltipProvider = Primitive.Provider;

export function Tooltip({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Primitive.Root>
      <Primitive.Trigger asChild>{children}</Primitive.Trigger>
      <Primitive.Portal>
        <Primitive.Content
          sideOffset={4}
          className="rounded bg-fg px-2 py-1 text-xs text-bg shadow"
        >
          {label}
        </Primitive.Content>
      </Primitive.Portal>
    </Primitive.Root>
  );
}
